import React from 'react';
import { useRouter } from 'next/router';

import cx from 'classnames';

import { useAppContext } from 'hooks/context/useAppContext';
import { useWebsite } from 'hooks/website/useWebsite';

import s from './Background.module.css';

type TProps = {
  contrast?: boolean;
};

const Background = ({ contrast = false }: TProps) => {
  const { publicUser } = useAppContext();
  const { pathname } = useRouter();

  const { home } = useWebsite();

  const heroImage = home.hero.image;

  const style = {
    ...(publicUser && {
      backgroundImage: `url(${heroImage})`,
    }),
  };

  const notBlurredPages = ['/', '/preview'];
  const displayBlur = !notBlurredPages.includes(pathname);

  return (
    <div className={s.root}>
      {heroImage && (
        <div className={s.image} style={displayBlur ? {} : style}>
          {displayBlur && <div className={s.blur} style={style} />}
          <div className={cx(s.overlay, contrast && s.overlayContrast)}>
            <div className={cx(s.gradient, contrast && s.gradientContrast)} />
            {contrast && <div className={s.bottomGradient} />}
          </div>
        </div>
      )}
    </div>
  );
};

export { Background };
